import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-secondary text-secondary-foreground" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-serif font-bold">L'Île Gourmande</h3>
            <p className="text-sm text-secondary-foreground/80 leading-relaxed">
              Une fusion unique entre les saveurs exotiques de Maurice et l'élégance de la cuisine bourguignonne.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Navigation</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-sm text-secondary-foreground/80 hover:text-white transition-colors">
                Accueil
              </Link>
              <Link to="/menu" className="text-sm text-secondary-foreground/80 hover:text-white transition-colors">
                Notre Carte
              </Link>
              <Link to="/about" className="text-sm text-secondary-foreground/80 hover:text-white transition-colors">
                Notre Histoire
              </Link>
              <Link to="/orders" className="text-sm text-secondary-foreground/80 hover:text-white transition-colors">
                Mes Commandes
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 mt-0.5 text-primary" />
                <div className="text-sm text-secondary-foreground/80">
                  <p>Zone de livraison:</p>
                  <p>Dijon & Gevrey-Chambertin</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-primary" />
                <span className="text-sm text-secondary-foreground/80">06 27 36 31 40</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-primary" />
                <span className="text-sm text-secondary-foreground/80">lilegourmande18@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Horaires</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Clock className="h-5 w-5 mt-0.5 text-primary" />
                <div className="text-sm text-secondary-foreground/80">
                  <p className="font-medium">Livraison</p>
                  <p>Jeu - Ven: 19h00 - 22h00</p>
                  <p>Sam - Dim: 11h00 - 14h00</p>
                  <p>Sam - Dim: 18h00 - 22h00</p>
                  <p className="mt-2 text-xs">Fermé du lundi au mercredi</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-secondary-foreground/60">
              © {new Date().getFullYear()} L'Île Gourmande. Tous droits réservés.
            </p>
            <div className="flex space-x-6">
              <Link to="/mentions-legales" className="text-xs text-secondary-foreground/60 hover:text-white transition-colors">
                Mentions légales
              </Link>
              <Link to="/cgv" className="text-xs text-secondary-foreground/60 hover:text-white transition-colors">
                CGV
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
